import { render, staticRenderFns } from "./ShoppingDetail.vue?vue&type=template&id=d4407a3a&scoped=true&"
import script from "./ShoppingDetail.vue?vue&type=script&lang=js&"
export * from "./ShoppingDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingDetail.vue?vue&type=style&index=0&id=d4407a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4407a3a",
  null
  
)

export default component.exports